module.exports = {
  colors: {
    red100: "#FBE6EA",
    red200: "#DE002E",
    red300: "#A30D2D",
    blue100: "#E6F2F8",
    blue200: "#007DB8",
    blue300: "#09638D",
    green100: "#E7F3EC",
    green200: "#0B8940",
    green300: "#106B39",
    purple100: "#F4ECF2",
    purple200: "#91467F",
    purple300: "#6E3C65",
    orange100: "#FCF1E7",
    orange200: "#E7760B",
    orange300: "#AA5E14",
    white: "#FFFFFF",
    gray100: "#F3F4F4",
    gray200: "#E9E9EA",
    gray300: "#D2D4D4",
    gray400: "#717779",
    gray500: "#4B5356",
    gray600: "#1F282C",
    black: "#000000",
  }
};